// Hocs
import asyncRoute from '../AsyncRoute'

// Exports
export function getComponent ({store}) {
  return new Promise((resolve) => {
    require.ensure([], (require) => {
      const View = require('hfty-users-dom').UsersManager

      resolve(View)

    /* Webpack named bundle   */
    }, 'users')
  })
}

export default asyncRoute({getComponent, reducers: []})
